import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker on every app load — independent of
// push notifications. The SW is needed for PWA install support
// (Chrome's "Install app" prompt requires an active SW), the
// manifest's standalone display mode, offline shell caching, and
// only THEN as a host for the push subscription. Previously it was
// registered lazily inside enablePushNotifications, so users who
// hadn't opted into push had no SW at all — meaning Chrome wouldn't
// offer to install Appozy as an app.
//
// Wrapped in load handler so the registration doesn't compete with
// initial page paint.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) => {
        // Don't crash the app if SW registration fails (e.g. user
        // is in a private window where SW is disabled).
        console.warn('Service worker registration failed:', err.message);
      });
  });
}